import { render, staticRenderFns } from "./FormPublications.vue?vue&type=template&id=a7180afe&scoped=true"
import script from "./FormPublications.vue?vue&type=script&lang=js"
export * from "./FormPublications.vue?vue&type=script&lang=js"
import style0 from "./FormPublications.vue?vue&type=style&index=0&id=a7180afe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7180afe",
  null
  
)

export default component.exports